<template>
    <div class="w-100 video-sequence advanced-search">
        <h2 class="vx-col w-full" style="text-align: center; margin: 0 0 20px 0">Asset sequence</h2>

        <vx-card>
            <div class="vx-row gutter-half mb-5 mt-3 d-flex align-center">
                <div class="vx-col w-full sm:w-full md:w-1/4">
                    <div class="d-flex align-center">
                        <span class="label">LM Format: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select LM Format"
                                  :options="$store.state.learningMapFormats"
                                  label="name"
                                  @input="() => { getGoals() }"
                                  :reduce="item => item.id"
                                  v-model="filters.lm_format_id">
                            <template #list-header>
                                <li style="text-align: center" v-if="!$store.state.learningMapFormats.length">Loading LM Formats...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/4" :class="{'filter-disabled': !goals.length}">
                    <div class="d-flex align-center">
                        <span class="label">Goal: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Goal"
                                  :options="goals"
                                  label="name"
                                  @input="() => { getGrades(); }"
                                  :reduce="item => item.name"
                                  :disabled="!goals.length"
                                  v-model="filters.goal">
                            <template #list-header>
                                <li style="text-align: center" v-if="!goals.length">Loading Goals...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/4" :class="{'filter-disabled': !grades.length}">
                    <div class="d-flex align-center">
                        <span class="label">Grade: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Grade"
                                  :options="grades"
                                  label="name"
                                  @input="() => { getSubjects(); }"
                                  :disabled="!grades.length"
                                  :reduce="item => item.name"
                                  v-model="filters.exam">
                            <template #list-header>
                                <li style="text-align: center" v-if="!grades.length">Loading Grades...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/4" :class="{'filter-disabled': !subjects.length}">
                    <div class="d-flex align-center">
                        <span class="label">Subject: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width left"
                                  placeholder="Select Subject"
                                  :options="subjects"
                                  label="name"
                                  :disabled="!subjects.length"
                                  :reduce="item => item.name"
                                  @input="() => { getUnits(); }"
                                  v-model="filters.subject">
                            <template #list-header>
                                <li style="text-align: center" v-if="!subjects.length">Loading Subjects...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
            </div>
            <div class="vx-row gutter-half mb-5 d-flex align-center">
                <div class="vx-col w-full sm:w-full md:w-1/3">
                    <div class="d-flex align-center" :class="{'filter-disabled': !units.length}">
                        <span class="label">Unit: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width left"
                                  placeholder="Select Unit"
                                  :options="units"
                                  label="name"
                                  :reduce="item => item.name"
                                  :disabled="!units.length"
                                  @input="() => { getChapters(); }"
                                  v-model="filters.unit">
                            <template #list-header>
                                <li style="text-align: center" v-if="!units.length">Loading Units...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/3">
                    <div class="d-flex align-center" :class="{'filter-disabled': !chapters.length}">
                        <span class="label">Chapter: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Chapter"
                                  :options="chapters"
                                  label="name"
                                  :disabled="!chapters.length"
                                  :reduce="item => item.name"
                                  @input="() => { getTopics(); }"
                                  v-model="filters.chapter">
                            <template #list-header>
                                <li style="text-align: center" v-if="!chapters.length">Loading Chapters...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/3" :class="{'filter-disabled': !topics.length}">
                    <div class="d-flex align-center">
                        <span class="label">Topic: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Topic"
                                  :options="topics"
                                  label="name"
                                  :clearable="false"
                                  :disabled="!topics.length"
                                  @input="() => { fetchItems() }"
                                  v-model="filters.topic">
                            <template #list-header>
                                <li style="text-align: center" v-if="!topics.length">Loading Topics...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
            <div class="loader-block loader-block2" v-if="isLoading">
                <div class="loading">
                    <div class="effect-1 effects"></div>
                    <div class="effect-2 effects"></div>
                    <div class="effect-3 effects"></div>
                </div>
            </div>
            <div class="pr vx-row" v-if="showTable">
                <div id="data-container" style="min-height: 30px;padding: 0 0.5rem; width: 100%" class="relative">
                    <div style="display: flex; justify-content: flex-end">
                        <vs-button color="primary" @click="saveSequence">
                            Save
                        </vs-button>
                    </div>
                    <div class="data-table mt-3">
                        <div class="d-flex vs-table-header" >
                            <div style="width: 25%">Title</div>
                            <div style="width: 16%">Type</div>
                            <div style="width: 14%">Academic Reviewed</div>
                            <div style="width: 14%">Artist Reviewed</div>
                            <div style="width: 14%">Readiness</div>
                            <div style="width: 10%">Thumbnail</div>
                            <div style="width: 7%; text-align: center" >Actions</div>
                        </div>
                        <draggable v-model="items" v-if="items && items.length > 0">
                            <transition-group>
                                <div class="d-flex align-center vs-table" v-for="(item, index) in items" :key="'item'-index">
                                    <div style="width: 25%">
                                        <router-link :to="$store.state.user.role.name === 'Authenticated' ? ('/' + item._id) : ('/' + item._id + '/edit')">
                                            {{item.title}}
                                        </router-link>
                                    </div>
                                    <div style="width: 16%">
                                        {{item.asset_type}}
                                    </div>
                                    <div style="width: 14%">
                                        {{ item.academic_reviewed ? 'Yes' : 'No' }}
                                    </div>
                                    <div style="width: 14%">
                                        {{ item.artist_reviewed ? 'Yes' : 'No' }}
                                    </div>
                                    <div style="width: 14%">
                                        {{ item.readiness ? 'Yes' : 'No' }}
                                    </div>
                                    <div style="width: 10%" class="asset-thumbnail-block">
                                        <div class="asset-thumbnail-section" @click="isAssetModal = item._id">
                                            <HoverThumb :main="item.thumbnail" :list="item.thumbnails" :asset="item" :ignoreList="true"/>
                                        </div>
                                    </div>
                                    <div style="width: 7%; display: flex; justify-content: center">
                                        <vs-button icon-pack="feather" color="primary" icon="icon-arrow-up" style="margin-right: 5px" @click.stop="drag(index, 0)"/>
                                        <vs-button icon-pack="feather" color="primary" icon="icon-arrow-down" @click.stop="drag(index, items.length - 1)"/>
                                    </div>
                                </div>

                            </transition-group>
                        </draggable>
                        <div v-if="!items || !items.length" style="width: 100%;text-align: center">
                            Nothing here
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>

        <assetModal :id="isAssetModal" v-if="isAssetModal" v-on:closeModal="closeAssetModal"/>
    </div>
</template>

<script>

import axios from "axios";
import vSelect from 'vue-select'
import AssetItem from "../components/AssetItem";
import draggable from 'vuedraggable'
import HoverThumb from "../components/HoverThumb";
import assetModal from "../components/modal/assetModal";

export default {
    name: "AssetSequence",
    components: {vSelect, AssetItem, draggable, HoverThumb, assetModal},
    props: {},
    data() {
        return {
            filters: {
                _search: "",
                subject: "",
                unit: "",
                chapter: "",
                topic: "",
                title: "",
                asset_types: [],
                // _start: 0,
                // _limit: 27,
                order_by: "updatedAt",
                order: "desc",
                academic_reviewed: false,
                artist_reviewed: false,
                visibility: 'public',
                published: false,
                lm_format_id: '',
                goal: '',
                exam: ''
            },
            subjects: [],
            units: [],
            chapters: [],
            topics: [],
            titles: [],
            goals: [],
            grades: [],
            selected: {},
            items: [],
            currentPage: 1,
            totalItems: 0,
            itemsPerPage: 15,
            totalPages: 0,
            showImages: true,
            isLoading: false,
            lmDebounce: false,
            lmFormats: [],
            sequence: null,
            showTable: false,
            isAssetModal: false
        }
    },
    computed: {
        componentName: () => {
            return "AssetSequence"
        },
        filtersObj() {
            return {
                _search: this.filters._search,
                subject: this.filters.subject,
                unit: this.filters.unit,
                chapter: this.filters.chapter,
                topic: this.filters.topic,
                title: this.filters.title,
                // _start: (this.currentPage - 1) * this.itemsPerPage,
                // _limit: this.itemsPerPage,
                order_by: this.filters.order_by,
                order: this.filters.order,
                academic_reviewed: this.filters.academic_reviewed,
                artist_reviewed: this.filters.artist_reviewed,
                visibility: this.filters.visibility,
                published: this.filters.published,
                lm_format_id: this.filters.lm_format_id,
                goal: this.filters.goal,
                exam: this.filters.exam,
            }
        },
        filtersQuery() {
            return Object.keys(this.filtersObj).filter(k => Boolean(this.filtersObj[k]) || this.filtersObj[k] === 0).map(k => `${k}=${k == 'topic' ? this.filtersObj[k].name : this.filtersObj[k]}`).join("&")
        }
    },
    mounted() {
        // this.getLMFormats();
        // this.topics = [{"_id":"5ec58c1d0c88fe5860972cff","name":"Logical Patterns","display_name":"Logical Patterns","code":"kve98455","lpcode":"kve97670--kve98310--kve98311--kve98341--kve98454--kve98455","learnpath_name":"cbse--2nd cbse--mathematics--geometry--patterns--logical patterns","learnpath_format_name":"goal--exam--subject--unit--chapter--topic","has_concepts":true,"practice":[],"cfu_practice":[],"description":"This topic explains in detail the various patterns we see around us every day. This includes patterns such as the ones we see on tiles, clothes, durries etc. It also includes an activity to identify number patterns.","cheat_sheet":"","learn_tile_image":"https://embibe.blob.core.windows.net/images/learn_tiles/f493af18-17cb-48e2-8547-3e2c8fdb0ccb_3x.webp","learn_tile_bg_image":"https://embibe.blob.core.windows.net/images/learn_backgrounds/6df4ed63-2550-4ba0-b7e2-f4727dcfa9ef_3x.webp","practice_tile_image":"https://embibe.blob.core.windows.net/images/practice_tiles/4c3e1f40-39d3-48ca-b512-4f5f77d8ea1c_3x.webp","practice_tile_bg_image":"https://embibe.blob.core.windows.net/images/practice_backgrounds/b66f2fec-528a-45c3-81cc-11b4b1b4a355_3x.webp","cfu_practice_tile_image":"","score":{"importance":7.3480697156882275,"difficulty_level":3.7736048245063833,"length":7.913974934040419,"fundamental_score":6.871613128956657,"complexity_score":7.1057139444766175,"oswaal_importance":4.882353595155728},"concepts":[],"learning_maps":[],"videos":[],"calendar_sequence":1,"academic_sequence":9}]
    },
    watch: {
        filtersObj(next, prev) {
            if (!compareObjects(next, prev) && this.filtersObj.subject && this.filtersObj.unit && this.filtersObj.chapter && this.filtersObj.topic) {
                this.fetchItems()
            }
        }
    },
    methods: {
        closeAssetModal() {
            this.isAssetModal = false;
        },
        saveSequence() {
            this.isLoading = true;
            let url = '/sequences';

            let id = null;
            if (this.sequence) {
                id = this.sequence._id;
                url += '/' + id;
            }

            let data = {
                name: this.filters.topic.name,
                topic_code: this.filters.topic.code
            }
            let sequence = [];
            for (let k in this.items) {
                sequence.push({
                    asset_id: this.items[k]._id,
                    order: Number(k)
                })
            }
            data.sequence = sequence;
            this.$axios[id ? 'put' : 'post'](url, data).then((res) => {
                this.isSaved = true;
                this.isLoading = false;
                this.$vs.notifyWrapper({
                    color: 'success',
                    fixed: true,
                    title: 'Updated Successfully'
                })
            }).catch(e => {
                this.isLoading = false;
            })
        },
        drag(indexFrom, indexTo) {
            let el = this.items[indexFrom];
            this.items.splice(indexFrom, 1);
            this.items.splice(indexTo, 0, el);
        },
        getLMFormats() {
            let url = `/lm-formats?lm_type=learning_map` + '&search=' + '';
            if (this.filters.search_type) {
                url += '&search_type=' + this.filters.search_type;
            }
            this.$axios.get(url).then(res => {
                this.lmFormats = res.data._items;
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        clear(fieldName) {
            const  map = ['goals', 'grades', 'subjects', 'units', 'chapters', 'topics', 'titles'].reverse();
            const clearMap = {
                goals: () => {this.goals = []; this.filters.goal = ''},
                grades: () => {this.grades = []; this.filters.exam = ''},
                subjects: () => {this.subjects = []; this.filters.subject = ''},
                units: () => {this.units = []; this.filters.unit = ''},
                chapters: () => {this.chapters = []; this.filters.chapter = ''},
                topics: () => {this.topics = []; this.filters.topic = ''},
                titles: () => {this.titles = []; this.filters.title = ''},
            }
            let ind = map.indexOf(fieldName);
            if (ind < 0) return;
            for (let i=0; i<=ind; i++) {
                clearMap[map[i]]();
            }
            this.items = [];
            this.totalPages = 0;
        },
        getGoals() {
            if (this.filters.lm_format_id) {
                this.clear("goals");
                let url = `/goals-list?id=${this.filters.lm_format_id}`;
                this.$axios.get(url).then(res => {
                    this.goals = Object.values(res.data)[0];
                }).catch(e => {
                    console.log(url, e.message)
                })
            }
        },
        getGrades() {
            this.clear("grades");
            let url = `/grades-list?id=${this.filters.lm_format_id}`;
            url += '&goal=' + this.filters.goal;
            this.$axios.get(url).then(res => {
              let d = Object.values(res.data)[0].sort(function(a, b) {
                return a.name.localeCompare(b.name, undefined, {
                  numeric: true,
                  sensitivity: 'base'
                });
              });
              this.grades = d;
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getSubjects() {
            this.clear("subjects");
            let url = `/subject-list?id=${this.filters.lm_format_id}`;
            url += '&goal=' + this.filters.goal;
            url += '&exam=' + this.filters.exam;
            this.$axios.get(url).then(res => {
                this.subjects = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getUnits() {
            this.clear("units");
            let url = `/units-list?id=${this.filters.lm_format_id}`;
            url += '&goal=' + this.filters.goal;
            url += '&exam=' + this.filters.exam;
            url += '&subject=' + this.filters.subject;
            this.$axios.get(url).then(res => {
                this.units = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getChapters() {
            this.clear("chapters");
            let url = `/chapters-list?id=${this.filters.lm_format_id}`;
            url += '&goal=' + this.filters.goal;
            url += '&exam=' + this.filters.exam;
            url += '&subject=' + this.filters.subject;
            url += '&unit=' + this.filters.unit;
            this.$axios.get(url).then(res => {
                this.chapters = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getTopics() {
            this.clear("topics");
            let url = `/topics-list?id=${this.filters.lm_format_id}`;
            url += '&goal=' + this.filters.goal;
            url += '&exam=' + this.filters.exam;
            url += '&subject=' + this.filters.subject;
            url += '&unit=' + this.filters.unit;
            url += '&chapter=' + this.filters.chapter;
            this.$axios.get(url).then(res => {
                this.topics = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        clearSearch() {
            this.filters._search = "";
            this.isLoading = false;
            if (this.cancelSearchToken && this.cancelSearchToken.cancel) {
                this.cancelSearchToken.cancel({err: "Operation canceled by user action."});
            }
        },
        fetchItems(force) {
            // if (this.filters._search.length < 3) return;
            this.isLoading = true;
            this.showTable = true;
            clearTimeout(this.fetchDebounce);
            this.fetchDebounce = setTimeout(() => {
                this.items = [];
                if (this.cancelSearchToken && this.cancelSearchToken.cancel) {
                    this.cancelSearchToken.cancel({err: "Operation canceled by new search.", newSearch: true});
                }
                this.conceptsLoading = true;
                this.cancelSearchToken = axios.CancelToken.source();
                this.$axios.get(`/assets/adv-search?${this.filtersQuery}`, {cancelToken: this.cancelSearchToken.token}).then(res => {
                    if (res.data && res.data.items && res.data.items.length) {
                        this.items = res.data.items;
                    }
                    this.totalItems = res.data.total;
                    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
                    this.cancelSearchToken = null;
                    if (this.items && this.items.length) {
                        this.getSequence();
                    } else {
                        this.isLoading = false;
                    }
                }).catch(e => {
                    console.log('catch_search', e)
                    this.items = [];
                    this.isLoading = Boolean(e.message.newSearch);
                    this.cancelSearchToken = null;
                })
            }, 500)
        },
        getSequence() {
            this.$axios.get(`/sequences?topic_code=${this.filters.topic.code}`).then(res => {
                if (res.data && res.data[0]) {
                    this.sequence = res.data[0];
                    let items = this.items;

                    for (let k in this.sequence.sequence) {
                        let fromIndex = this.items.findIndex(item => item._id == this.sequence.sequence[k].asset_id);
                        let toIndex = this.sequence.sequence[k].order;
                        if (fromIndex || fromIndex === 0) {
                            let element = items[fromIndex];
                            items.splice(fromIndex, 1);
                            items.splice(toIndex, 0, element);
                        }
                    }
                    this.items = items;
                } else {
                    this.sequence = null;
                }
                this.isLoading = false;
            }).catch(e => {
                console.log('catch_search', e)
                this.items = [];
                this.isLoading = false;
                this.cancelSearchToken = null;
            })
        },
    },
}

function compareObjects(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }

    return true;
}
</script>
